module.exports = __webpack_public_path__ + "img/ecu_banner_hk.c3fdef85.jpg";